var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuetify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "293px",
    viewBox: "0 0 256 293",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "#1697F6",
    points: "128 0 68 0 128 141.816367"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#1867C0",
    points: "128 0 188 0 128 141.816367"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#7BC6FF",
    points: "128 182.743732 128 292.459439 0 42.5575194 67.0490402 42.5575194"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#AEDDFF",
    points: "128 182.746214 128 292.461921 256 42.5600014 188.95096 42.5600014"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuetify);
export default __webpack_public_path__ + "static/media/vuetify.4802839b4078c6ccaef34895464fef96.svg";
export { ForwardRef as ReactComponent };